import { render, staticRenderFns } from "./ControlCenter.vue?vue&type=template&id=b8b8d6c6&scoped=true&"
import script from "./ControlCenter.vue?vue&type=script&lang=ts&"
export * from "./ControlCenter.vue?vue&type=script&lang=ts&"
import style0 from "./ControlCenter.vue?vue&type=style&index=0&id=b8b8d6c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b8d6c6",
  null
  
)

export default component.exports